export const BOARD_BASIS = ["RO", "SC", "BB", "HB", "FB", "AI", "RD"];

export const PRICE_RANGE = [1, 999999] as const;
